import { useState } from 'react';

/**
 * 다단계 폼 상태를 관리하는 훅
 * @param {number} totalSteps - 전체 단계 수
 * @returns {{
 *   currentStep: number,
 *   stepData: object,
 *   goToNextStep: Function,
 *   goToPrevStep: Function,
 *   goToStep: Function,
 *   updateStepData: Function,
 *   resetSteps: Function,
 *   isFirstStep: boolean,
 *   isLastStep: boolean
 * }}
 */
export const useMultiStep = (totalSteps = 2) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [stepData, setStepData] = useState({});

  const goToNextStep = (data = {}) => {
    setStepData(prev => ({ ...prev, ...data }));
    if (currentStep < totalSteps - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const goToPrevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const goToStep = (stepIndex) => {
    if (stepIndex >= 0 && stepIndex < totalSteps) {
      setCurrentStep(stepIndex);
    }
  };

  const updateStepData = (data) => {
    setStepData(prev => ({ ...prev, ...data }));
  };

  const resetSteps = () => {
    setCurrentStep(0);
    setStepData({});
  };

  return {
    currentStep,
    stepData,
    goToNextStep,
    goToPrevStep,
    goToStep,
    updateStepData,
    resetSteps,
    isFirstStep: currentStep === 0,
    isLastStep: currentStep === totalSteps - 1
  };
};

export default useMultiStep;
